import React, {Component, PureComponent} from "react";
import Form from 'react-bootstrap/Form';
import TrayTypeSelecter from "./TrayTypeSelecter";
import TraySelecter from "./TraySelecter";
import TrayCoverSelecter from "./TrayCoverSelecter";
import TrayConnSelecter from "./TrayConnSelecter";
import {Dictionary, helper}  from "./../app.js"; 

export default class TrayConfigurator extends Component 
{
    constructor (props)
    {
        super(props);
        this.processSelected = this.processSelected.bind(this);
    }
    static getTrayFilterKey (tray_filter)
    {
        return `ts_${tray_filter.type}_${tray_filter.perforated}`;
    }
    processSelected (item, type, showInfo = true)
    {
        //console.log(item, type);
        
        switch (type)
        {
            case 'tray_filter':

                if (TrayConfigurator.getTrayFilterKey(item) !== TrayConfigurator.getTrayFilterKey(this.props.tray_filter))
                {
                    this.props.on_select_item(item, 'tray_filter', showInfo);
                    this.props.on_select_item(null, 'tray', showInfo);
                    this.props.on_select_item(null, 'tray_cover', showInfo);
                    this.props.on_select_item(null, 'tray_connector', showInfo);
                }
                break;

            case 'tray':

                const tray = this.props.tray;
                if (
                    !helper.isNotObjectOrEmpty(item)
                    && 
                    !helper.isNotObjectOrEmpty(tray)
                    && 
                    item.id != tray.id
                )
                {
                    if ('quantity' in item)
                    {
                        this.props.on_select_item(null, 'tray_cover', showInfo);
                        this.props.on_select_item(null, 'tray_connector', showInfo);
                        this.props.on_select_item(item, 'tray', showInfo);
                    }
                    else
                    {
                        this.props.on_select_item(null, 'tray', showInfo);
                        this.props.on_select_item(item, 'tray', showInfo);
                    }
                }
                else
                    this.props.on_select_item(item, 'tray', showInfo);
                break;

            default:

                this.props.on_select_item(item, type, showInfo);
                break;
        }
    }
    render() 
    {
        const trayTypeProps = {
                types: Dictionary.instance.get('tray_types')
            }, 
            coverProps = {
                init_cover: this.props.cover
            },
            tray = this.props.tray,
            hasTray = !helper.isNotObjectOrEmpty(tray),
            trayID = hasTray ? tray.id : '',
            trayKey = TrayConfigurator.getTrayFilterKey(this.props.tray_filter);
        ({
            type: trayTypeProps.type,
            perforated: trayTypeProps.perforated 
        } = this.props.tray_filter);

        ({
            articul: coverProps.tray_articul = '',
            width: coverProps.tray_width = 0,
            length: coverProps.tray_length = 0,
            quantity: coverProps.tray_quantity = 0
        } = hasTray ? tray : {});

        //console.log(coverProps);
        //console.log(this.props.connector);

        return (
            <Form>
                <TrayTypeSelecter on_select={this.processSelected} {...trayTypeProps} />                
                <TraySelecter key={trayKey} on_select={this.processSelected} tray={tray} filter={this.props.tray_filter} />
                <TrayCoverSelecter key={`tcov_${trayID}`} on_select={this.processSelected} {...coverProps} />
                <TrayConnSelecter key={`tcon_${trayID}`} on_select={this.processSelected} tray_articul={hasTray ? tray.articul : ''} tray_quantity={hasTray ? tray.quantity : ''} init_connector={this.props.connector} />
            </Form>
        );
    }
}